import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck, MessagesSquare, Truck } from "lucide-react";
import { useLang } from "../context/LangContext";
import { BrandMark } from "../components/Navbar";

export default function About() {
  const { t } = useLang();
  return (
    <div data-testid="about-page" className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <BrandMark />
      <h1 className="font-heading mt-8 text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900">{t("about_t")}</h1>
      <p className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">{t("about_p1")}</p>
      <p className="mt-3 text-base sm:text-lg text-slate-600 leading-relaxed">{t("about_p2")}</p>
      <div className="mt-10 grid sm:grid-cols-3 gap-4">
        {[
          { icon: ShieldCheck, t: t("verified_trusted") },
          { icon: MessagesSquare, t: t("quick_rfq") },
          { icon: Truck, t: t("delivery_addr") },
        ].map(({ icon: Icon, t: label }, i) => (
          <div key={i} className="rounded-2xl border border-slate-200 bg-white p-5 flex items-center gap-3">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-teal-700/10 text-teal-700">
              <Icon className="h-5 w-5" />
            </div>
            <p className="font-heading text-sm font-bold text-slate-900">{label}</p>
          </div>
        ))}
      </div>
      <Link
        data-testid="about-join"
        to="/register"
        className="mt-10 inline-flex items-center gap-2 rounded-full bg-teal-700 px-6 py-3 text-sm font-bold text-white hover:bg-teal-800 transition active:scale-95 shadow-lg shadow-teal-700/25"
      >
        {t("join_now")} <ArrowRight className="h-4 w-4" />
      </Link>
    </div>
  );
}
